import { t } from "@/i18n-js/instance";
import { planTiers } from "@/react/helpers/planHelpers";
import valuePropEn1x from "@circle-assets/images/features/ai-actions/en/value-prop_1x.png";
import valuePropEn2x from "@circle-assets/images/features/ai-actions/en/value-prop_2x.png";
import { usePlanStatus } from "@circle-react/hooks/usePlanStatus";
import { useUpgradePlanModal } from "@circle-react-shared/UpgradePlan";
import { UPGRADE_FLOW_SOURCES } from "@circle-react-shared/UpgradePlan/constants";
import { useFetchPlan } from "@circle-react-shared/UpgradePlan/hooks/useFetchPlan";
import { Modal } from "@circle-react-uikit/ModalV2";
import { LeftSide } from "./LeftSide";
import { RightSide } from "./RightSide";

interface ModalBodyProps {
  handleClose: () => void;
}

export const ModalBody = ({ handleClose }: ModalBodyProps) => {
  const upgradePlanModal = useUpgradePlanModal();
  const { defaultCurrency } = usePlanStatus();
  const { plan: enterprisePlan, isPlanLoading } = useFetchPlan({
    planTier: planTiers.enterprise,
    billingCurrency: defaultCurrency || undefined,
  });

  const handleActivate = async () => {
    handleClose(); // Hide the AI Actions Modal first
    await upgradePlanModal.show({
      planTier: planTiers.enterprise,
      showPlanDetails: false,
      successButtonLabel: t("pricing_plans.upgrade_modal.actions.close"),
      source: UPGRADE_FLOW_SOURCES.AI_ACTIONS_ENABLE_MODAL,
    });
  };

  // [TODO][AiActions][AfterRelease] Add translated images for portuguese language
  const image1x = valuePropEn1x;
  const image2x = valuePropEn2x;
  const imageVariants = {
    thumbnail: image1x,
    small: image1x,
    medium: image1x,
    large: image2x,
  };

  const handleLearnMore = () => {
    // eslint-disable-next-line sonarjs/link-with-target-blank -- Disabled for plugin version update. Fix when possible.
    window.open(
      "https://help.circle.so/c/workflow-setup/getting-started-with-ai-workflows",
      "_blank",
    );
  };

  return (
    <Modal.Body>
      <div className="flex h-full gap-8 pb-6 pt-4">
        <LeftSide
          handleActivate={handleActivate}
          handleLearnMore={handleLearnMore}
          plan={enterprisePlan}
          isPlanLoading={isPlanLoading}
        />
        <RightSide
          image1x={image1x}
          imageVariants={imageVariants}
          alt={t("settings.ai_actions.modal.image_alt")}
          plan={enterprisePlan}
          isLoading={isPlanLoading}
        />
      </div>
    </Modal.Body>
  );
};
